import componentMixin from './mixin';
import componentHelpers from './helpers';
var componentDef = {
  mixins: [componentMixin],
  template: componentHelpers.inlineTemplate,
  data: function data() {
    return {};
  },
  inject: ['pageTemplate', 'pageLoading'],
  computed: {
    asyncPageTemplate: function asyncPageTemplate() {
      return this.pageTemplate;
    },
    loading: function loading() {
      return this.pageLoading;
    }
  }
};
export default componentDef;